import { useEffect, useRef } from "react";

declare global {
  interface Window {
    __HEADER__?: {
      html: string;
    };
  }
}

const defaultHeaderHtml = `<header class="bg-white border-b border-gray-200 shadow-sm">
  <div class="max-w-4xl mx-auto px-5">
    <div class="flex items-center justify-between py-4">
      <div class="flex items-center">
        <div class="h-12 w-32 bg-gray-200 rounded" style="display: flex; align-items: center; justify-content: center; color: #666; font-size: 12px;">Logo</div>
      </div>
    </div>
  </div>
</header>`;

export const Header = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      const headerScript = document.getElementById('header-html');
      let html = headerScript?.textContent || window.__HEADER__?.html || defaultHeaderHtml;
      // Unescape the </script> we escaped server-side
      html = html.replace(/&lt;\/script&gt;/gi, '</script>');
      containerRef.current.innerHTML = html;
    }
  }, []);

  return (
    <div ref={containerRef} />
  );
};
